<div class="row justify-content-start align-items-center flex-wrap mt-2">
  <div class="col-auto" *ngFor="let wasabiPath of log">
    <ag-shr-image-with-loader
      class="ag-main-info__image"
      [wasabiPath]="wasabiPath | getWasabiPathWithoutTimestamp"
    ></ag-shr-image-with-loader>
  </div>
</div>
